import { useContext, useState } from 'react'

import { useHistory, useRouteMatch } from 'react-router-dom'

import InterneoAccountForm from './InterneoAccountForm'
import AppLoading from '../../Components/shared/AppLoading'
import InternshipRequestPortalFormProvider, { Modes } from '../../Providers/Forms/InternshipRequestPortal/InternshipRequestPortalFormProvider'
import { RequestPortalContext } from '../../Providers/RequestPortalProvider'
import { Routes } from '../../routes'
import PortalLayout, { REQUESTER_STYLE } from './PortalLayout'
import RedirectToLoginCountdown from './RedirectToLoginCountdown'
import usePortalResolution from './usePortalResolution'
import { getPortalOwnerName } from '../../utils/api/internshipRequestPortal'

const InternshipRequestPortal = () => {
  const { setInstitution, setPortalAccessKey } = useContext(RequestPortalContext)

  const history = useHistory()

  const studentMatch = useRouteMatch(Routes.INTERNSHIP_REQUEST_PORTAL_STUDENT)
  const isStudentPortal = studentMatch?.isExact === true

  const { portalData, errorMessage, loadedLanguageTag, isResolved } = usePortalResolution(isStudentPortal)

  const [portalMode, setPortalMode] = useState('')
  const [isRedirecting, setIsRedirecting] = useState(false)

  const handleHasAccount = () => {
    setInstitution(portalData.institution)
    setPortalAccessKey(portalData.accessKey)
    setIsRedirecting(true)
  }

  if (loadedLanguageTag.length === 0 && (portalData.institution === null || portalData.institutionGroup === null)) {
    return <AppLoading />
  }

  const isRequesterPhase = portalMode.length === 0
  const isRequesterCard = isRequesterPhase || isRedirecting

  return (
    <PortalLayout
      portalData={portalData}
      errorMessage={errorMessage}
      displayInstitution={!isRequesterCard}
      style={isRequesterCard ? REQUESTER_STYLE : undefined}
    >
      {isRedirecting && (
        <RedirectToLoginCountdown onRedirect={() => history.push(Routes.LOGIN)} />
      )}

      {isResolved && !isRedirecting && (
        <InternshipRequestPortalFormProvider
          institutionGroup={portalData.institutionGroup}
          institution={portalData.institution}
          portalAccessKey={portalData.accessKey}
          initialMode={isStudentPortal ? Modes.STUDENT : null}
          visible={portalMode.length > 0}
          onReset={() => setPortalMode('')}
          Wrapper={(({ children }) => <div>{children}</div>)}
        >
          <InterneoAccountForm
            institutionName={getPortalOwnerName(portalData)}
            visible={isRequesterPhase}
            onPortalRedirection={setPortalMode}
            onHasAccount={handleHasAccount}
          />
        </InternshipRequestPortalFormProvider>
      )}
    </PortalLayout>
  )
}

export default InternshipRequestPortal
